import Marquee from "react-fast-marquee";

const ITEMS = ["Nurhan & Emre", "04 · 09 · 2026", "Rotterdam", "Hoş geldiniz", "Welkom"];

export default function Ribbon({ direction = "left", color = "turq" }) {
  const bg = color === "turq" ? "bg-turq" : "bg-ink";
  return (
    <div data-testid="marquee-ribbon" className={`${bg} py-4 md:py-5 overflow-hidden`}>
      <Marquee speed={40} direction={direction} gradient={false} autoFill>
        {ITEMS.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="marquee-item text-2xl md:text-4xl italic text-cream px-8">
              {item}
            </span>
            <span className="text-gold text-xl px-2">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
